__webpack_require__.p = "/events/vsw24/";